import React, { useCallback } from "react";

import { DateTime } from "luxon";
import { TimeInput } from "./TimeInput";

interface ITimePickerProps{
    shownDate: DateTime, 
    setShownDate: React.Dispatch<React.SetStateAction<DateTime>>,
    minDate: DateTime | undefined,
    maxDate: DateTime | undefined
}

const TimePicker = (props: ITimePickerProps) => {
    // Handle time change with validation
    const handleTimeChange = useCallback((type: "hour" | "minute" | "second", newValue: number) => {
        if (type === "hour" && (newValue < 0 || newValue > 23)) return;
        if (type === "minute" && (newValue < 0 || newValue > 59)) return;
        if (type === "second" && (newValue < 0 || newValue > 59)) return;

        props.setShownDate((prev) => prev.set({ [type]: newValue }));
    }, [props]);

    // Check if buttons should be disabled
    const isDisabled = useCallback((type: "hour" | "minute" | "second", value: number) => {
        const updated = props.shownDate.set({ [type]: value });
        return (props.minDate && updated < props.minDate) || (props.maxDate && updated > props.maxDate);
    }, [props.maxDate, props.minDate, props.shownDate]);

    return (
        <div className="time-inputs">
            <TimeInput
                label="Hour"
                value={props.shownDate.hour}
                min={0}
                max={23}
                onChange={(value:number) => handleTimeChange("hour", value)}
                disableUp={isDisabled("hour", props.shownDate.hour + 1)}
                disableDown={isDisabled("hour", props.shownDate.hour - 1)}
            />

            <>:</>

            <TimeInput
                label="Minute"
                value={props.shownDate.minute}
                min={0}
                max={59}
                onChange={(value:number) => handleTimeChange("minute", value)}
                disableUp={isDisabled("minute", props.shownDate.minute + 1)}
                disableDown={isDisabled("minute", props.shownDate.minute - 1)}
            />

            <>:</>

            <TimeInput
                label="Second"
                value={props.shownDate.second}
                min={0}
                max={59}
                onChange={(value:number) => handleTimeChange("second", value)}
                disableUp={isDisabled("second", props.shownDate.second + 1)}
                disableDown={isDisabled("second", props.shownDate.second - 1)}
            />
        </div>
    );
};

export default TimePicker;
